import { render, staticRenderFns } from "./edit-supplier.vue?vue&type=template&id=11b323e8&"
import script from "./edit-supplier.vue?vue&type=script&lang=ts&"
export * from "./edit-supplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-supplier.vue"
export default component.exports